import { create } from "zustand"

interface DeleteChildModalProps {
  isOpen: boolean
  onClose: () => void
  onOpen: (childUserId: number) => void

  childUserId: number | null
}

const useDeleteChildModalStore = create<DeleteChildModalProps>((set) => ({
  isOpen: false,
  onClose: () => set({ isOpen: false }),
  onOpen: (childUserId) => set({ isOpen: true, childUserId }),
  childUserId: null,
}))

export default useDeleteChildModalStore
